import { Pencil } from "lucide-react";
import { ActionIcon, Drawer, LoadingOverlay } from "@mantine/core";
import React, { useEffect, useState } from "react";
import { HttpClientError } from "../../../providers/HttpClient";
import TagMetadataForm from "../components/TagMetadataForm";
import useTagDetailsApiService from "../services/api/TagDetailsApiService";
import { useToasts } from "../../../providers/notifications/ToastsContext";

type UpdateTagActionIconProps = {
  id: number;
};

const UpdateTagActionIcon: React.FC<UpdateTagActionIconProps> = ({ id }) => {
  const [opened, setOpened] = useState(false);
  const {
    isLoading,
    isError,
    error,
    refetch,
    isRefetchError,
    isSuccess,
    data,
  } = useTagDetailsApiService(id, false);
  const { showToast } = useToasts();

  useEffect(() => {
    if (isError || isRefetchError) {
      showToast({
        strapiId: "update_tag_failed",
        data: {
          message: HttpClientError(error),
        },
      });

      setOpened(false);
    }
  }, [isError, error]);

  useEffect(() => {
    if (opened) {
      refetch().then();
    }
  }, [opened]);

  return (
    <>
      <LoadingOverlay visible={isLoading} />
      <Drawer
        opened={isSuccess && opened}
        size="xl"
        onClose={() => setOpened(false)}
        title="Update a Tag"
        overlayOpacity={0.1}
        overlayBlur={3}
        position="right"
      >
        <div style={{ padding: "25px", height: "80%", overflow: "auto" }}>
          <TagMetadataForm
            tagId={id}
            initialName={data?.name || ""}
            initialCategory={data?.category || ""}
            onSuccess={() => setOpened(false)}
          />
        </div>
      </Drawer>

      <ActionIcon onClick={() => setOpened(true)}>
        <Pencil size={18} />
      </ActionIcon>
    </>
  );
};

export default UpdateTagActionIcon;
